import api, { ResponseCallback } from '../services/api.service'

export interface TimezoneData {
  id: number
  name: string
}

const routes = {
  list: '/timezones'
}

export default {
  list (callback: ResponseCallback<TimezoneData[]>) {
    api.get(routes.list, {}, callback)
  }
}
